/*
 * DON'T TOUCH, USED IN PIPELINE BUILD
 */
export const environment = {
  production: true,
  defaultLangCode: 'FR',
  RefTranslationTypeCode: 'OFFICE_COMMON',
  RefParamTypeCode: 'KIOSK_SITE',
  kioskMode: false,
  apiBaseUrl: './api',
  bgColor: "#ecf1f5",
  authenticatorUrl: './Authenticator',
  login: '',
  password: ''
};